module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-entity-page"
  }, [(_vm.item) ? _c(_vm.itemComponent, {
    tag: "component",
    attrs: {
      "item": _vm.item,
      "type": 'expanded',
      "id": _vm.item.id
    },
    on: {
      "refresh": _vm.refresh
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-77ca8c42!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/EntityPage.vue
// module id = 2610
// module chunks = 1